import React, { useEffect } from 'react';
import classNames from 'classnames';

interface Props {
    list: string[];
    // 方向
    reverse?: boolean;
}

const keyframesLeft = `
@keyframes scroll-left {
    0% { transform: translateX(0); }
    100% { transform: translateX(calc(-100% - var(--brands-gap, 0px))); }
}
`;
const keyframesRight = `
    @keyframes scroll-right {
    0% { transform: translateX(calc(-100% - var(--brands-gap, 0px))); }
    100% { transform: translateX(0); }
}
`;
const LoopPlayback: React.FC<Props> = ({ list, reverse }) => {
    useEffect(() => {
        const style = document.createElement('style');
        document.head.appendChild(style);
        style.sheet?.insertRule(!reverse ? keyframesLeft : keyframesRight, 0);
        return () => {
            style.remove();
        };
    }, []);
    return (
        <div className={classNames('brands-container', { reverse })}>
            <div className="brands-ani">
                <div className="brands">
                    {[...list].map((item, idx) => (
                        <div className="brand-item" key={idx}>
                            <img src={item} />
                        </div>
                    ))}
                </div>
                {/* 复制一层用于循环 */}
                {Array.from({ length: 2 }).map((i, idx1) => (
                    <div className="brands" key={idx1}>
                        {[...list].map((item, idx2) => (
                            <div className="brand-item" key={`${idx1}-${idx2}`}>
                                <img src={item} />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
export default LoopPlayback;
